var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { MoveGenerator } from '../../jscaip/AI/AI';
import { Debug } from '../../utils/Debug';
import { GoMove } from './GoMove';
import { GoPiece } from './GoPiece';
let AbstractGoMoveGenerator = class AbstractGoMoveGenerator extends MoveGenerator {
    rules;
    constructor(rules) {
        super();
        this.rules = rules;
    }
    getListMoves(node, config) {
        const currentState = node.gameState;
        const playingMoves = this.getPlayingMovesList(currentState, config);
        if (currentState.phase.isPlaying() || currentState.phase.isPassed()) {
            playingMoves.push(GoMove.PASS);
            return playingMoves;
        }
        else {
            const markingMoves = this.getCountingMovesList(currentState, config);
            if (markingMoves.length === 0) {
                return [GoMove.ACCEPT];
            }
            else {
                return markingMoves;
            }
        }
    }
    getPlayingMovesList(state, config) {
        const choices = [];
        for (const coordAndContent of state.getCoordsAndContents()) {
            const coord = coordAndContent.coord;
            const content = coordAndContent.content;
            const newMove = new GoMove(coord.x, coord.y);
            if (content === GoPiece.EMPTY) {
                const legality = this.rules.isLegal(newMove, state, config);
                if (legality.isSuccess()) {
                    choices.push(newMove);
                }
            }
        }
        return choices;
    }
    getCountingMovesList(currentState, config) {
        const choices = [];
        // 1. put all to dead
        // 2. find all mono-wrapped empty group
        // 3. set alive their unique wrapper
        // 4. list the remaining "entry points" of dead group
        // 5. remove the entry points which on the true actual board are link to an already dead group
        // 6. return that list of alive group that AI consider dead
        const correctBoard = this.getCorrectBoard(currentState).getCopiedBoard();
        const zoom = this.rules.getZoom(config);
        const groupDataFactory = this.rules.getGoGroupDataFactory(zoom);
        const groupsData = groupDataFactory.getGroupsDataWhere(correctBoard, (piece) => piece !== GoPiece.EMPTY && piece !== GoPiece.UNREACHABLE);
        for (const group of groupsData) {
            const coord = group.getCoords()[0];
            const correctContent = correctBoard[coord.y][coord.x];
            const actualContent = currentState.getPieceAt(coord);
            if (actualContent !== correctContent) {
                const move = new GoMove(coord.x, coord.y);
                choices.push(move);
                return choices;
            }
        }
        return choices;
    }
    getCorrectBoard(currentState) {
        const markAsDead = (piece) => {
            if (piece === GoPiece.DARK)
                return GoPiece.DEAD_DARK;
            if (piece === GoPiece.LIGHT)
                return GoPiece.DEAD_LIGHT;
            if (piece.isTerritory()) {
                return GoPiece.EMPTY;
            }
            else {
                return piece;
            }
        };
        const allDeadBoard = this.mapBoard(currentState.getCopiedBoard(), markAsDead);
        const allDeadState = currentState.withBoard(allDeadBoard);
        const territoryLikeGroups = this.rules.getTerritoryLikeGroup(allDeadState);
        return this.setAliveUniqueWrapper(allDeadState, territoryLikeGroups);
    }
    mapBoard(board, mapper) {
        const newBoard = [];
        for (let y = 0; y < board.length; y++) {
            newBoard[y] = [];
            for (let x = 0; x < board[0].length; x++) {
                newBoard[y][x] = mapper(board[y][x]);
            }
        }
        return newBoard;
    }
    setAliveUniqueWrapper(allDeadState, monoWrappedEmptyGroups) {
        let resultingState = allDeadState;
        let aliveCoords;
        for (const monoWrappedEmptyGroup of monoWrappedEmptyGroups) {
            aliveCoords = monoWrappedEmptyGroup.deadDarkCoords.concat(monoWrappedEmptyGroup.deadLightCoords);
            for (const aliveCoord of aliveCoords) {
                if (resultingState.isDead(aliveCoord)) {
                    resultingState = this.rules.switchLiveness(aliveCoord, resultingState, 1);
                }
            }
        }
        return resultingState;
    }
};
AbstractGoMoveGenerator = __decorate([
    Debug.log
], AbstractGoMoveGenerator);
export { AbstractGoMoveGenerator };
